export const PartnerRequestModel = (formData, urlSearchParams) => {
  const { name, title, phone, email, addressFrom, addressTo, surface, dateField, propertyFound, optIn } = formData
  let utmMedium = urlSearchParams.utm_medium

  if (global.showNextoriesNewTitle) utmMedium = utmMedium ? '&abtest' : 'abtest'

  return {
    mode: 1,
    source: 'SE_LOGER',
    coordinates: {
      title: title.value,
      surname: name.value,
      phone: phone.value,
      email: email.value,
    },
    departure: {
      postalCode: addressFrom.value.zipCodeValue,
      city: addressFrom.value.Tag || '',
      surface: surface.value,
    },
    arrival: {
      postalCode: addressTo.value.zipCodeValue,
      city: addressTo.value.Tag || '',
    },
    dates: {
      earlier: dateField.value,
    },
    details: {
      comments: propertyFound.checked ? 'J’ai déjà trouvé mon bien' : 'Je n’ai pas encore trouvé mon bien',
    },
    optInEnergy: optIn.checked,
    utmSource: 'form_SL',
    utmMedium,
  }
}
